<template>
  <div class="container">
    <!-- 서브상단영역 -->

    <Banner
      title="etc"
      subtitle="etc"
      description="학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>
        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
    />

    <Navbar />

    <div class="width_wrap">
      <Sidebar />
      <div class="body_content sub">
        <!-- 서브 타이틀영역 -->
        <h1 class="sub_subject">철학<span></span></h1>
        <!-- //서브 타이틀영역 -->

        <div class="sub0102_wrap">
          <div class="box02 box03">
            <h1>철학</h1>
            <h2>
              “코코랩COKOLab”이란 회사명칭은 시대 정신을 기반으로 하는 회사의
              설립 배경과 핵심 가치를 담고 있습니다. “COKOLab”은 COnnectome
              based Knowledge Organization Laboratory의 약어로, 21C를 움직이는
              키워드의 합성어입니다. 인간의 뇌신경지도를 일컫는 'Connectome'은
              ‘개인 스스로 자신의 뇌신경계를 만들어간다’는 의미를 담고 있습니다.
              AI 기술의 핵심 개념이기도 합니다. 'Knowledge Organization'은
              Connectome의 성장 기제로, 'Knowledge'는 생존 도구로서의 지식을,
              'Organization'은 변화에 적응하기 위한 자발적 창발 활동을 뜻합니다.
              이 둘의 결합이 'Connectome'을 만들어갑니다. 이 개념들은 21C 핵심
              가치로 미래 사회의 진화 패러다임을 규정짓습니다. 끝으로,
              'Laboratory'는 코코랩이 개인의 창조적 진화를 지원하기 위해
              끊임없이 연구, 성장, 진화하겠다는 약속입니다.
            </h2>
            <h2>
              코코랩은 성장기 학생의 창조 역량을 진단하고 교육하기 위한 목적으로
              설립되었습니다. 코코랩은 분야 최고 전문가들의 전문성, 연구 경험,
              특별한 교육 철학을 근간으로, 그리고, 설립자의 지난 30여 년 동안의
              경험 - 미국 영재교육 현장 장기 체류 경험, 창의적 성취 연구 경험,
              국가 영재교육기관 지원 경험을 바탕으로 조직되었습니다.
              학문적으로는 성장기 학생이 지금 살고 있는 현재와 앞으로 살아갈
              미래를 관통하는 시대 정신, 즉, 복잡계, 세상의 생명체설, 지식의
              생명체설, 진화론, 게놈, 양자역학, 다원적 우주론, 자기조직화,
              인지과학, 그리고 커넥톰 등을 배경으로 하고 있습니다. 궁극적으로,
              코코랩은 개인의 창조적 진화를 반영하는 역량시스템을 구축하여
              성장기 학생들에게 자기 이해 기회, 나아가, 스스로 역량을 최적화,
              극대화, 고도화하는 기회를 제공함으로써, 그들이 창조적 삶을
              만들어가는 데 기여하고자 합니다.
            </h2>
            <div>
              <figure>
                <img
                  src="@/assets/img/philosophy.png"
                  style="width: 500px"
                  alt="철학"
                />
              </figure>
              <p>
                창조 역량은 미래 사회가 개인에게 요구하는 핵심역량이다.<br />
                창조 역량은 일상, 학업, 진로, 진학, 직업, 삶 전반에서
                필요하다.<br />
                <br />
                창조 역량은 타고난 재능, 관심, 경험으로 성장한다.<br />
                창조 역량은 도전적 활동이 지속되어 진화한 결과이다.<br />
                <br />
                창조 역량은 미성숙한 행동과 성숙한 행동의 상호작용 결과이다.
                <br />
                창조 역량은 체계적 진단을 통한 자기 이해에서 시작된다 .
              </p>
            </div>
          </div>
          <!--box02-->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Navbar from "@/views/etc/Navbar.vue";
import Sidebar from "@/views/etc/page/Sidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";

const isOpen = ref(false);

// 토글 함수
function toggleRow() {
  isOpen.value = !isOpen.value;
}
</script>

<style scoped>
.scbd .sp-ico {
  background-image: url("@/assets/img_up/shop_pds/kp708b/design/rwdClear/sp-icons@2x.png");
  background-size: 300px 250px;
}

.sub_title_01 p {
  position: absolute;
  top: 70px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 30px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 600;
}
.sub_title_01 h2 {
  position: absolute;
  top: 130px;
  left: 0;
  margin-top: -15px;
  width: 100%;
  font-size: 19px;
  color: #fff;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  line-height: 1.7em;
}

.box02 {
  clear: both;
  margin-bottom: 50px;
}
.box02 h1 {
  font-size: 24px;
  padding: 10px 0 70px;
  margin-bottom: 20px;
  text-align: center;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  position: relative;
}
.box02 h1:before {
  content: "";
  margin: 0 auto 10px auto;
  width: 30px;
  height: 2px;
  background: #ba7b3d;
  display: block;
}
.box02 h1:after {
  position: absolute;
  content: "";
  bottom: 10px;
  left: 50%;
  margin-left: -0.5px;
  width: 1px;
  height: 30px;
  background: #ccc;
}
.box02 > div {
  background: #fff;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 30px;
  margin-top: 10px;
}

.box02 h2 {
  font-size: 15px;
  margin-bottom: 10px;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: normal;
  text-align: justify;
}

.box03 > div {
  background: #fff;
  text-align: center;
  position: relative;
  box-sizing: border-box;
  margin-bottom: 30px;
  padding: 60px 20px 70px 20px; /*숫자수정*/
  margin-top: 30px;
}

.box03 > div > figure {
  margin-bottom: 60px;
}

.box02 > div.box2 {
  border-top: 1px solid #ddd;
}
.box02 > div.box2:after {
  display: none;
}
.box02 > div:last-child {
  margin-bottom: 0;
}
.box02 > div > h2 {
  font-size: 17px;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  font-weight: 500;
  text-align: center;
  color: #ba7b3d;
}
.box02 > div > p,
.box02 > p {
  font-size: 14px;
  line-height: 1.6em;
  font-family: "Noto Sans", "Nanum Gothic", "Malgun Gothic", sans-serif;
  word-break: keep-all;
  text-align: center;
}
.box02 > div > p > span {
  display: inline-block;
  padding: 10px 20px 0 20px;
}
.box02 > p {
  margin: 20px 0;
}

@media screen and (min-width: 768px) {
  .box02 h1 {
    font-size: 22px;
  }
  .box02 > div > p,
  .box02 > p {
    font-size: 16px;
  }
}
@media screen and (min-width: 1100px) {
}
</style>
